import type { ReactNode } from "react";
import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";
import { ArrowUpRight } from "lucide-react";

/**
 * Sonnet'in ürettiği Markdown brifingi executive tarzda render eder.
 * "Neden önemli:" satırları ve kaynak linkleri özel olarak vurgulanır.
 */
const components: Components = {
          h1: ({ children }) => (
            <h2 className="font-serif text-2xl text-slate-50">{children}</h2>
          ),
          h2: ({ children }) => (
            <h3 className="mt-7 font-serif text-xl leading-snug text-slate-50">{children}</h3>
          ),
          h3: ({ children }) => (
            <h4 className="mt-6 font-serif text-lg text-slate-100">{children}</h4>
          ),
          p: ({ children }) => {
            // "Neden önemli:" notunu altın aksanla işaretle
            const text = Array.isArray(children) ? children : [children];
            const first = typeof text[0] === "string" ? text[0] : "";
            if (/^neden önemli/i.test(first.trim())) {
              return (
                <p className="mt-2 border-l-2 border-gold/50 bg-gold/[0.04] py-2 pl-4 text-sm text-slate-300">
                  {children}
                </p>
              );
            }
            return <p className="mt-2 leading-relaxed text-slate-300">{children}</p>;
          },
          strong: ({ children }) => <strong className="font-semibold text-slate-100">{children}</strong>,
          ul: ({ children }) => <ul className="mt-2 space-y-1.5 pl-1">{children}</ul>,
          li: ({ children }) => (
            <li className="flex gap-2 text-slate-300">
              <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-gold/70" />
              <span>{children}</span>
            </li>
          ),
          a: ({ children, href }) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-0.5 font-medium text-gold transition-colors hover:text-gold-300"
            >
              {children}
              <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          ),
  hr: () => <div className="rule-gold my-6" />,
  blockquote: ({ children }: { children?: ReactNode }) => (
    <blockquote className="border-l-2 border-slate-600 pl-4 text-slate-400">{children}</blockquote>
  ),
};

export function DigestView({ markdown }: { markdown: string }) {
  return (
    <article className="space-y-4">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {markdown}
      </ReactMarkdown>
    </article>
  );
}
